import { combineReducers } from '@reduxjs/toolkit';
import userReducer from './slices/userSlice';
import problemsReducer from './slices/problemsSlice';
import solutionReducer from './slices/solutionSlice';
import subtasksReducer from './slices/subtasksSlice';
import rollenReducer from './slices/rollenSlice';
import SubtasksProcessedSlice from './slices/subtasksProcessedSlice';
import { chatReducer } from './slices/chat';

const rootReducer = combineReducers({
  user: userReducer,
  problems: problemsReducer,
  subtasks: subtasksReducer,
  rollen: rollenReducer,
  subtasksProcessed: SubtasksProcessedSlice,
  solution: solutionReducer,
  chat: chatReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
